import Button from '@/components/base/Button';

interface CTASectionProps {
  title: string;
  subtitle?: string;
  primaryLabel?: string;
  primaryTo?: string;
  secondaryLabel?: string;
  secondaryTo?: string;
  variant?: 'light' | 'dark';
}

export default function CTASection({
  title,
  subtitle,
  primaryLabel = '無料で今すぐお試し',
  primaryTo = '/free-trial/',
  secondaryLabel = 'デモ・導入相談を予約する',
  secondaryTo = '/contact/',
  variant = 'light',
}: CTASectionProps) {
  const bgClass = variant === 'dark' ? 'bg-background-900' : 'bg-primary-50';
  const titleClass = variant === 'dark' ? 'text-background-50' : 'text-foreground-950';
  const subtitleClass = variant === 'dark' ? 'text-background-300' : 'text-foreground-600';

  // GA4/GTM計測用: 遷移先からCTA種別を導出（location は常に bottom）。
  // 該当しない遷移先（例: /features/ の「機能を見る」）は無印のまま。
  const ctaNameOf = (to?: string): string | undefined => {
    if (to === '/free-trial/') return 'free_trial';
    if (to === '/contact/') return 'demo_contact';
    return undefined;
  };

  return (
    <section className={`${bgClass} py-16 md:py-20`}>
      <div className="max-w-[800px] mx-auto px-4 md:px-6 text-center">
        <h2 className={`text-2xl md:text-3xl font-bold mb-4 ${titleClass}`}>{title}</h2>
        {subtitle && <p className={`text-base mb-8 ${subtitleClass}`}>{subtitle}</p>}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button to={primaryTo} size="lg" dataCtaName={ctaNameOf(primaryTo)} dataCtaLocation={ctaNameOf(primaryTo) ? 'bottom' : undefined}>
            {primaryLabel}
          </Button>
          <Button to={secondaryTo} variant="outline" size="lg" dataCtaName={ctaNameOf(secondaryTo)} dataCtaLocation={ctaNameOf(secondaryTo) ? 'bottom' : undefined}>
            {secondaryLabel}
          </Button>
        </div>
      </div>
    </section>
  );
}
